import { render, staticRenderFns } from "./UserScientificDegreeChangeActivationType.vue?vue&type=template&id=75701d68&"
import script from "./UserScientificDegreeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegreeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports